import styled from 'styled-components';

import { FIXED_STICKY_FOOTER_HEIGHT } from 'components/sticky-footer/constants';
import { primitive } from 'styles/constants/primitives';

export const Section = styled.div`
  z-index: ${Styles.zIndex.overlay + 150};
  ${Styles.desktop`
    max-width: 350px;
    width: 350px;
  `}
`;

export const StyledTabs = styled.div`
  display: flex;
  background: ${Styles.color.primary};
  flex-direction: column;
  align-items: center;
  padding: ${primitive.$spacing5};
  padding-bottom: 0;
  height: auto;
  flex: 1 1 auto;
`;

export const StyledTabPanels = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  padding-bottom: calc(${FIXED_STICKY_FOOTER_HEIGHT} + ${primitive.$spacing5});
  height: calc(100vh - ${FIXED_STICKY_FOOTER_HEIGHT});
  overflow-y: auto;
  & > div {
    padding: ${primitive.$spacing0} ${primitive.$spacing5};
    height: fit-content;
    min-height: fit-content;
  }
`;

export const AppBarStyle = styled.header`
  display: flex;
  width: 80%;
  padding: 0;
`;
